<template>
    <div class="tabs">
        <el-menu
            :default-active="String(activeVersion)"
            active-text-color="#fec2c4"
            class="tabs"
            mode="horizontal"
            @select="handleSelect"
        >
            <el-menu-item
                :key="index"
                :index="String(index)"
                :disabled="isPreview || activeVersion == index"
                v-for="(version, index) in scene.versions"
            >
                {{ version.name }}
            </el-menu-item>
        </el-menu>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Editor from '../../../classes/Editor'

export default {
    computed: {
        ...mapGetters('creator', ['project', 'scene', 'activeScene', 'activeVersion', 'isPreview']),
    },
    methods: {
        ...mapActions('creator', ['setActiveSceneVersion']),
        async handleSelect(key) {

            // We have to clear selection before tab change because after clear selection we have 
            // called callbacks and after that content of canvas is stored for wrong version
            Editor.canvas.discardActiveObject()

            this.setActiveSceneVersion({
                scene: this.activeScene,
                version: key,
            });

            await Editor.loadVersion(this.activeVersion, this.activeScene)
        },
    },
}
</script>